import { FC, ReactNode } from 'react';
import styled from './index.module.scss';

interface IProps {
    title?: string;
    subtitle?: string;
    icon?: ReactNode;
}

const ProductHeader: FC<IProps> = ({ title, subtitle }) => {
    return (
        <div className={`${styled.ProductHeader}`}>
            {title && <h6 className="product_title">{title}</h6>}
            {subtitle && <p className="product_subtitle">{subtitle}</p>}
        </div>
    );
};

export default ProductHeader;
